export class S3DetectPartitionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "layout",
            "baseName": "layout",
            "type": "S3PartitionLayout",
            "format": ""
        },
        {
            "name": "bucketPathPartitionSpec",
            "baseName": "bucketPathPartitionSpec",
            "type": "BucketPathPartitionSpec",
            "format": ""
        },
        {
            "name": "samplePaths",
            "baseName": "samplePaths",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3DetectPartitionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
